import emoji from 'node-emoji'
import inquirer, { Answers } from 'inquirer'
import chalk from 'chalk'

import { ExtendedQuestion } from '../../../types'
import {
  CircleApiUtils,
  displayEnvCreationResults,
  circleApiQuestions,
  buildEnvQuestions,
  buildEnvsFromAnswers,
} from '../utils'

const askQuestions = inquirer.prompt

// eslint-disable-next-line no-shadow
export enum ANDROID_QUESTIONS_ENVS {
  KEY_FILE = 'KEY_FILE',
  KEYSTORE_BASE64 = 'KEYSTORE_BASE64',
  KEYSTORE_ALIAS = 'KEYSTORE_ALIAS',
  KEYSTORE_PASSWORD = 'KEYSTORE_PASSWORD',
  GOOGLE_PLAY_KEY = 'GOOGLE_PLAY_KEY',
  SLACK_URL = 'SLACK_URL',
}

export const androidQuestionsMap: { [key: string]: ExtendedQuestion } = {
  [ANDROID_QUESTIONS_ENVS.KEY_FILE]: {
    type: 'input',
    name: 'keyFile',
    prefix: emoji.random().emoji,
    message: 'Please enter your key file name:',
  },
  [ANDROID_QUESTIONS_ENVS.KEYSTORE_BASE64]: {
    type: 'input',
    name: 'keystoreBase64',
    prefix: emoji.random().emoji,
    message: 'Please enter your keystore base64 string:',
  },
  [ANDROID_QUESTIONS_ENVS.KEYSTORE_ALIAS]: {
    type: 'input',
    name: 'keystoreAlias',
    prefix: emoji.random().emoji,
    message: 'Please enter your keystore alias:',
  },
  [ANDROID_QUESTIONS_ENVS.KEYSTORE_PASSWORD]: {
    type: 'input',
    name: 'keystorePassword',
    prefix: emoji.random().emoji,
    message: 'Please enter your keystore password:',
  },
  [ANDROID_QUESTIONS_ENVS.GOOGLE_PLAY_KEY]: {
    type: 'input',
    name: 'matchAwsAccessKeyId',
    prefix: emoji.random().emoji,
    message: 'Please enter your google play key:',
  },
  [ANDROID_QUESTIONS_ENVS.SLACK_URL]: {
    type: 'input',
    name: 'slackUrl',
    prefix: emoji.random().emoji,
    message: 'Please enter your slack url:',
  },
}

const buildAndroidQuestions = (selectedEnvs: ANDROID_QUESTIONS_ENVS[]) =>
  buildEnvQuestions(selectedEnvs, androidQuestionsMap)

const buildAndroidEnvs = (selectedEnvs: string[], androidEnvAnswers: Answers) =>
  buildEnvsFromAnswers(selectedEnvs, androidEnvAnswers, androidQuestionsMap)

// NOTE: this only works as a special case because key and values are the same.
export const androidEnvsList = Object.keys(ANDROID_QUESTIONS_ENVS)

const circleQuestions = [
  ...circleApiQuestions,
  {
    type: 'checkbox',
    name: 'selectedEnvs',
    prefix: emoji.random().emoji,
    message: 'Please select the envs you would like to create/update:',
    choices: androidEnvsList,
  },
]

export const createAndroidCircleEnvs = async (): Promise<void> => {
  try {
    console.info(`${chalk.green('Creating CircleCI envs...')} \n`)
    const circleAnswers = await askQuestions(circleQuestions)
    const { selectedEnvs } = circleAnswers
    const ANDROIDEnvQuestions = buildAndroidQuestions(circleAnswers.selectedEnvs)
    const ANDROIDEnvAnswers = await askQuestions(ANDROIDEnvQuestions)

    const envs = buildAndroidEnvs(selectedEnvs, ANDROIDEnvAnswers)
    const utils = new CircleApiUtils({ token: circleAnswers.circleToken, projectSlug: circleAnswers.projectSlug })

    const creationResults = await utils.createEnvs(envs)
    displayEnvCreationResults(envs, creationResults)
  } catch (error) {
    console.error(error.message)
  }
}
